import { Device } from 'twilio-client';
import * as types from '../store/mutation-types';
import store from '../store';
import diallerApi from '../api/dialler';

const device = Device;
device.on('disconnect', () => {
  store.commit(types.SET_TWILIO_ON_PHONE_STATE, false);
  console.info('Twilio disconncted');
});

device.on('ready', () => {
  store.commit(types.SET_TWILIO_OFFLINE_STATE, false);
  console.info('Twilio ready');
});

device.on('offline', () => {
  store.commit(types.SET_TWILIO_OFFLINE_STATE, true);
  console.info('Twilio offline');
});

device.on('error', error => {
  const jwtExpiredCode = 31205;
  if (error.code === jwtExpiredCode) {
    diallerApi.getDeviceToken().then(response => {
      device.setup(response.token, {
        closeProtection: true,
        codecPreferences: ['opus', 'pcmu'],
        enableRingingState: true,
        name: store.getters.UserName
      });
    });
  } else {
    console.error(error.message);
  }
});

export default device;
